<template>
	<div class="quod-logo"></div>
</template>

<script>
export default {
	name: 'quod-logo',
};
</script>

<style lang="scss" scoped>
.quod-logo {
	position: absolute;
	width: 60px;
	height: 60px;
	background-image: url( '/img/quod-logo.jpg' );
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
}
</style>
